import { render } from "./ContentHeader.vue?vue&type=template&id=e2bd15fc"
const script = {}

import "./ContentHeader.vue?vue&type=style&index=0&id=e2bd15fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__